import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import ReactImageMagnify from 'react-image-magnify';
import { Button } from 'react-bootstrap';


import ExcelTicketSummary from '../../components/ExcelTicketSummary';


const propTypes = exact({
  selectedIndex: PropTypes.number.isRequired,
  selectIndex: PropTypes.func.isRequired,
  fileCount: PropTypes.number.isRequired,
  file: PropTypes.object.isRequired,
  multipage: PropTypes.bool.isRequired,
});


const FileViewer = (props) => {
  const {
    file,
    selectIndex,
    selectedIndex,
    fileCount,
    multipage,
  } = props;

  const { contentType, url, excelTicketSummary } = file;

  const renderControls = () => {
    return (
      <React.Fragment>
        <Button className="btn" onClick={(e) => { selectIndex(selectedIndex - 1); }}>
          Prev
        </Button>
        {' '}
        Page {selectedIndex + 1} of {fileCount}
        {' '}
        <Button className="btn" onClick={(e) => { selectIndex(selectedIndex + 1); }}>
          Next
        </Button>
      </React.Fragment>
    );
  };

  switch (contentType) {
    case 'excel':
      return (
        <ExcelTicketSummary
          excel_ticket_summary={excelTicketSummary}
          fileUrl={url}
        />
      );
    default:
      return (
        <React.Fragment>
          {multipage && renderControls()}
          <ReactImageMagnify
            className="imageView-imageContainer"
            {...{
              smallImage: {
                alt: 'submissions',
                isFluidWidth: true,
                src: url,
              },
              largeImage: {
                alt: '',
                src: url,
                width: 1600,
                height: 2000,
              },
              hoverDelayInMs: 500,
              enlargedImagePosition: 'over',
            }}
          />
        </React.Fragment>
      );
  }
};


FileViewer.propTypes = propTypes;


export default FileViewer;
